import React, { cloneElement, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { TYPE } from "../../../../../../../../constant";
import { useUserInfo } from "../../../../../../../../hooks";
import Button from "../../../../../../../common/Button";

const SubmitButtons = ( props ) => {

  const { t } = useTranslation();
  const { info } = useUserInfo();

  const {
    children,
    ...PROPS
  } = props;

  return (
    <table summary="키패드">
      <tbody>
      <tr>
        <td className="left">
          { cloneElement( children || <Fragment />, { ...PROPS } ) }
        </td>
        <td className="grading">
          <Button className="btn btn-blue" onClick={ props.onAnswering }>{ t( 'LC_05_20.msg008' ) }</Button>
        </td>
        {
          (info?.channelCode && (info.channelCode !== TYPE.CHANNEL.GLOBAL01)) && (
            <td className="arr_area">
              <Button className="lr_arr blue" onClick={props.onPrevCursor}><img src={`${process.env.PUBLIC_URL}/static/images/icon/keypad/ic_lc_answermove_back.svg`} alt="" /></Button>
              <Button className="lr_arr blue" onClick={props.onNextCursor}><img src={`${process.env.PUBLIC_URL}/static/images/icon/keypad/ic_lc_answermove_next.svg`} alt="" /></Button>
            </td>
          )
        }
      </tr>
      </tbody>
    </table>
  );

};

export default SubmitButtons;
